'use client'

import React from 'react'

type Props = {
    pressure1: number
    volume1: number
    pressure2: number
    volume2: number
}

const WIDTH = 340
const HEIGHT = 200
const PAD_LEFT = 40
const PAD_RIGHT = 12
const PAD_TOP = 14
const PAD_BOTTOM = 28
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const PLOT_H = HEIGHT - PAD_TOP - PAD_BOTTOM

export default function BoyleLawChart({ pressure1, volume1, pressure2, volume2 }: Props) {
    const p1 = Math.max(pressure1, 0.0001)
    const v1 = Math.max(volume1, 0.0001)
    const p2 = Math.max(pressure2, 0.0001)
    const v2 = Math.max(volume2, 0.0001)
    const k = p1 * v1

    const vMin = Math.min(v1, v2) * 0.5
    const vMax = Math.max(v1, v2) * 1.6
    const pMax = Math.max(p1, p2, k / vMin) * 1.1

    const xToSvg = (v: number) => PAD_LEFT + ((v - vMin) / (vMax - vMin)) * PLOT_W
    const yToSvg = (p: number) => PAD_TOP + PLOT_H - (p / pMax) * PLOT_H

    const points: string[] = []
    const steps = 60
    for (let i = 0; i <= steps; i++) {
        const v = vMin + ((vMax - vMin) * i) / steps
        const p = k / v
        points.push(`${xToSvg(v).toFixed(1)},${yToSvg(Math.min(p, pMax)).toFixed(1)}`)
    }

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={PAD_LEFT} y1={PAD_TOP} x2={PAD_LEFT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <line x1={PAD_LEFT} y1={HEIGHT - PAD_BOTTOM} x2={WIDTH - PAD_RIGHT} y2={HEIGHT - PAD_BOTTOM} stroke="#9ca3af" strokeWidth={1} />
            <text x={PAD_LEFT} y={HEIGHT - 8} fontSize={10} fill="#6b7280">V</text>
            <text x={4} y={PAD_TOP + 6} fontSize={10} fill="#6b7280">P</text>
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            <circle cx={xToSvg(v1)} cy={yToSvg(Math.min(p1, pMax))} r={4.5} fill="#16a34a" stroke="#fff" strokeWidth={1.5} />
            <text x={xToSvg(v1)} y={yToSvg(Math.min(p1, pMax)) - 8} fontSize={10} textAnchor="middle" fill="#16a34a">1</text>
            <circle cx={xToSvg(v2)} cy={yToSvg(Math.min(p2, pMax))} r={4.5} fill="#dc2626" stroke="#fff" strokeWidth={1.5} />
            <text x={xToSvg(v2)} y={yToSvg(Math.min(p2, pMax)) - 8} fontSize={10} textAnchor="middle" fill="#dc2626">2</text>
        </svg>
    )
}
